import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "instruction_view" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instruction_steps.entries(), ([index, inst]) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(inst), 1 /* TEXT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}